<template>
	<div class="grid-flex-container">
		<report-grid-toolbar
			:quickFilter="quickFilter"
			:advancedFilter="advancedFilter"
			:visibleColumns="visibleColumns"
			:hiddenColumns="hiddenColumns"
			@quickFilterChanged="onQuickFilterChanged"
			@advancedFilterChanged="onAdvancedFilterChanged"
		/>

		<div class="generic-grid-container">
			<grid-view
				v-if="visibleColumns"
				:gridData="gridData"
				:irisUserMetadata="irisUserMetadata"
				:loadingData="gridLoading"
				:visibleColumns="visibleColumns"
				:sorting="sorting"
				:page="page"
				:rowsPerPage="rowsPerPage"
				:totalCount="totalCount"
				:hasActions="true"
				@rowsPerPageChanged="onRowsPerPageChanged"
				@pageChanged="onPageChanged"
				@sortChanged="onSortChanged"
			>
				<template v-slot:[`actionsColumns`]> </template>
			</grid-view>
		</div>
	</div>
</template>
<script>
import { ReportGridGetters } from '../../../store/getters';
import { mapGetters } from 'vuex';
import { ReportGridActions } from '../../../store/actions';
import GridView from '../../shared/gridViews/GridView.vue';
import ReportGridToolbar from './ReportGridToolbar.vue';
export default {
	name: 'ReportGrid',
	components: { GridView, ReportGridToolbar },
	computed: {
		...mapGetters({
			selectedReportPreview: [ReportGridGetters.SELECTED_REPORT_PREVIEW],
			gridView: [ReportGridGetters.GRIDVIEW],
			gridLoading: [ReportGridGetters.GRID_LOADING],
			gridData: [ReportGridGetters.GRID_DATA],
			irisUserMetadata: [ReportGridGetters.IRIS_USER_METADATA],
			totalCount: [ReportGridGetters.TOTAL_COUNT],

			visibleColumns: [ReportGridGetters.VISIBLE_COLUMNS],
			hiddenColumns: [ReportGridGetters.HIDDEN_COLUMNS],
			page: [ReportGridGetters.PAGE],
			rowsPerPage: [ReportGridGetters.ROWS_PER_PAGE],
			sorting: [ReportGridGetters.SORTING],

			quickFilter: [ReportGridGetters.QUICK_FILTER],
			advancedFilter: [ReportGridGetters.ADVANCED_FILTER],
		}),
		currentReportId() {
			return this.$route.params.reportId;
		},
		currentGridViewId() {
			return this.$route.params.gridViewId;
		},
	},
	mounted() {
		this.$store
			.dispatch(ReportGridActions.LOAD_REPORT_PREVIEW, {
				reportId: this.currentReportId,
				gridViewId: this.currentGridViewId,
			})
			.then((success) => {
				if (!success) return;
				this.$store.dispatch(ReportGridActions.LOAD_GRID_DATA);
			});
	},
	methods: {
		onPageChanged(value) {
			this.$store.dispatch(ReportGridActions.UPDATE_PAGE, value);
		},
		onRowsPerPageChanged(value) {
			this.$store.dispatch(ReportGridActions.UPDATE_ROWS_PER_PAGE, value);
		},
		onSortChanged(value) {
			this.$store.dispatch(ReportGridActions.UPDATE_SORTING, value);
		},
		onQuickFilterChanged(value) {
			this.$store.dispatch(ReportGridActions.UPDATE_QUICK_FILTER, value);
		},
		onAdvancedFilterChanged(value) {
			this.$store.dispatch(
				ReportGridActions.UPDATE_ADVANCED_FILTER,
				value
			);
		},
	},
	destroyed() {
		this.$store.dispatch(ReportGridActions.CLEAR);
	},
};
</script>
